import { createFileRoute } from "@tanstack/react-router";
import { PlatformPage } from "../features/platform/PlatformPage";

// Deliberately outside the /w/$ws tree: this console is above every workspace, and
// hanging it off one would suggest it belonged to that workspace.
export type PlatformTab = "overview" | "workspaces" | "people" | "admins" | "neural" | "board" | "market";

const TABS: readonly PlatformTab[] = [
  "overview",
  "workspaces",
  "people",
  "admins",
  "neural",
  "board",
  "market",
];

export type PlatformSearch = { tab?: PlatformTab; ws?: string; user?: string };

export const Route = createFileRoute("/platform")({
  // `?tab=people&user=<id>`, `?tab=workspaces&ws=<id>`: every view has a link.
  validateSearch: (s: Record<string, unknown>): PlatformSearch => {
    const out: PlatformSearch = {};
    if (typeof s.tab === "string" && (TABS as readonly string[]).includes(s.tab) && s.tab !== "overview") {
      out.tab = s.tab as PlatformTab;
    }
    if (typeof s.ws === "string" && /^\d+$/.test(s.ws)) out.ws = s.ws;
    if (typeof s.user === "string" && /^\d+$/.test(s.user)) out.user = s.user;
    return out;
  },
  component: PlatformPage,
});
